/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: FoodiGo
  Author: Tan Tran
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app/index'
import cart from './modules/carts/index'
import restaurants from './modules/restaurants/index'
import menus from './modules/menus/index'
import payment from './modules/payment/index'
import orderManager from './modules/orderManager/index'
import orders from './modules/orders/index'
import favourites from './modules/favourites/index'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: app,
    cart: cart,
    favourites: favourites,
    restaurants: restaurants,
    menus: menus,
    payment: payment,
    orderManager: orderManager,
    orders: orders
  }
})
